__turbopack_context__.v({
  "card": "CServices-module__WZyYVW__card",
  "cardBadge": "CServices-module__WZyYVW__cardBadge",
  "cardBody": "CServices-module__WZyYVW__cardBody",
  "cardCta": "CServices-module__WZyYVW__cardCta",
  "cardDesc": "CServices-module__WZyYVW__cardDesc",
  "cardDot": "CServices-module__WZyYVW__cardDot",
  "cardDotActive": "CServices-module__WZyYVW__cardDotActive",
  "cardDotMuted": "CServices-module__WZyYVW__cardDotMuted",
  "cardIconWrap": "CServices-module__WZyYVW__cardIconWrap",
  "cardLink": "CServices-module__WZyYVW__cardLink",
  "cardTitle": "CServices-module__WZyYVW__cardTitle",
  "cards": "CServices-module__WZyYVW__cards",
  "categorySection": "CServices-module__WZyYVW__categorySection",
  "categoryTitle": "CServices-module__WZyYVW__categoryTitle",
  "cta": "CServices-module__WZyYVW__cta",
  "ctaButton": "CServices-module__WZyYVW__ctaButton",
  "ctaDescription": "CServices-module__WZyYVW__ctaDescription",
  "ctaInner": "CServices-module__WZyYVW__ctaInner",
  "ctaTitle": "CServices-module__WZyYVW__ctaTitle",
  "empty": "CServices-module__WZyYVW__empty",
  "hero": "CServices-module__WZyYVW__hero",
  "heroDescription": "CServices-module__WZyYVW__heroDescription",
  "heroEyebrow": "CServices-module__WZyYVW__heroEyebrow",
  "heroInner": "CServices-module__WZyYVW__heroInner",
  "heroTitle": "CServices-module__WZyYVW__heroTitle",
  "root": "CServices-module__WZyYVW__root",
});
